module.exports = __webpack_public_path__ + "static/media/2DGACM6.3e768695.jpg";